import { useState } from "react";
import { THeaderV2Props } from "../../header-v2";
import MobileMenuModal from "../mobile-menu-modal/mobile-menu-modal";
import MobileFirstLevelMenu from "../mobile-first-level-menu/mobile-first-level-menu";
import MobileSecondLevelMenu from "../mobile-second-level-menu/mobile-second-level-menu";

type TMobileMenuFoldupProps = Omit<THeaderV2Props, "logoUrl"> & {
  onClickClose: () => void;
  isOpen: boolean;
  portalContainer: HTMLElement | null;
};

const MobileFoldupMenu = ({
  menuItems,
  featureLinks,
  isOpen,
  portalContainer,
  onClickClose,
}: TMobileMenuFoldupProps) => {
  const [activeCategory, setActiveCategory] = useState<number | null>(null);

  const activeCategoryData = activeCategory !== null ? menuItems[activeCategory] : null;

  return (
    <div>
      <MobileMenuModal
        portalContainer={portalContainer}
        anchor="bottom"
        isOpen={isOpen}
        close={{ function: onClickClose }}
      >
        <MobileFirstLevelMenu
          menuItems={menuItems}
          featureLinks={featureLinks}
          onClickClose={onClickClose}
          onClickCategory={setActiveCategory}
        />
      </MobileMenuModal>
      <MobileMenuModal
        portalContainer={portalContainer}
        anchor={isOpen ? "right" : "bottom"}
        isOpen={isOpen && activeCategory !== null}
        close={{ function: onClickClose }}
      >
        <MobileSecondLevelMenu
          title={activeCategoryData?.title}
          menuItems={activeCategoryData?.links}
          onClickClose={() => {
            setActiveCategory(null);
            onClickClose();
          }}
          onClickBack={() => setActiveCategory(null)}
        />
      </MobileMenuModal>
    </div>
  );
};

export default MobileFoldupMenu;
